import UserContentHeader from "../../header/usercontentheader/usercontentheader";
import Table from "../../../../ui/table/table";
import TableHeaderContent from "../../../../ui/tableheadercontent/tableheadercontent";
import Button from "../../../../core/button/button";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import EditIcon from "../../../../modules/icons/edit";
import {SimpleTable} from "../../../../modals/types/table";
import ButtonDropdownMenu from "../../../../ui/dropdownmenu/buttondropdownmenu/buttondropdownmenu";
import ThreeDotsIcon from "../../../../modules/icons/threedots";
import "./siteandappacceptor.scss"
import DeleteIcon from "../../../../modules/icons/delete";
import {DropDownItem} from "../../../../modals/types/dropdown";
import DropDown from "../../../../ui/dropdown/dropdown";
import Popup from "../../../../ui/popup/popup";
import {useState} from "react";
import FilterIcon from "../../../../modules/icons/filter";
import CheckBox from "../../../../ui/checkbox/checkbox";

const SiteAndAppAcceptor = () => {
    const [openPopup, setOpenPopup] = useState(false);
    const mediaTypeDropDownItems: DropDownItem[] = [
        {label: "آیتم 1"}, {label: "آیتم 2"}, {label: "آیتم 3"}, {label: "آیتم 4"}
    ];
    const groupItems = [
        {domain: 'www.azarbaydegan.ir', rank: '10450826'},
        {domain: 'appnab.ir', rank: '10450826'},
        {domain: 'bazyarwork.ir', rank: '10450826'},
        {domain: 'gashtaninews.com', rank: '10450826'},
        {domain: 'www.sandoghche.ir', rank: '10450826'},
        {domain: 'www.azarbaydegan.ir', rank: '10450826'},
        {domain: 'appnab.ir', rank: '10450826'},
        {domain: 'bazyarwork.ir', rank: '10450826'},
        {domain: 'gashtaninews.com', rank: '10450826'},
        {domain: 'www.sandoghche.ir', rank: '10450826'},
    ]
    const popupInside = (
        <div className="row">
            <div className="col-lg-6 col-12 mb-3">
                <h6 className="pt-4 pb-1">عنوان گروه منتخب</h6>
                <input type="text" name="" id="" className="Campaign-Input" placeholder="انتخاب کنید"/>
            </div>
            <div className="col-lg-6 col-12 mb-3">
                <h6 className="pt-4 pb-1">نوع رسانه رسانه گروه</h6>
                <DropDown items={mediaTypeDropDownItems} placeHolder="انتخاب کنید ( سایت  یا تلگرام )"/>
            </div>
            <div className="col-12">
                <div className="Group-List w-100">
                    <div className="Group-List-Header">
                        <span className="Group-List-Header-Text">لیست سایت های نمایش دهنده</span>
                        <button className="Group-List-Header-Button">
                            <FilterIcon/>
                            &nbsp;&nbsp;
                            فیلتر کردن
                        </button>
                    </div>
                    <div className="Group-List-Body">
                        <div className="row border-bottom Group-List-Body-Header">
                            <div className="col-2"></div>
                            <div className="col-5">دامنه</div>
                            <div className="col-5">رتبه سیمیلار وب</div>
                        </div>
                        {
                            groupItems.map((groupItem, index) => {
                                return (
                                    <div key={index} className="row border-bottom Group-List-Body-Content">
                                        <div className="col-2"><CheckBox/></div>
                                        <div className="col-5">{groupItem.domain}</div>
                                        <div className="col-5">{groupItem.rank}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="w-100 d-block text-center Group-List-Button mt-3">
                    <Button type={"primary-light"} action={() => {
                        setOpenPopup(false)
                    }} responsive={true}>انصراف</Button>
                    <Button type={"primary"} action={() => {
                        setOpenPopup(false)
                    }} responsive={true}>ذخیره گروه</Button>
                </div>
            </div>
        </div>
    )
    const contentHeaderBox: JSX.Element = (
        <Button type={"secondary"} action={() => {
            setOpenPopup(true);
        }} responsive={true}>
            <AddCircleOutlineOutlinedIcon/>
            &nbsp;&nbsp;
            ساخت گروه
        </Button>
    )
    const buttonDropMenu = (
        [
            {
                icon: <DeleteIcon/>, title: 'حذف', action: () => {
                }
            },
            {
                icon: <EditIcon/>, title: 'ویرایش', action: () => {
                }
            }
        ]
    )
    const tableData: SimpleTable = {
        headers: ["شناسه", "نام گروه", "تعداد", "نوع", "عملیات"],
        bodies: [
            ["1793", "کمپین روز مادر", "10 سایت", "سایت",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["1071", "موبایل سامسونگ", "6 سایت", "سایت",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5380", "نوتیف/مشهد/موبایل", "20 اپلیکیشن", "اینستاگرام",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5389", "لپ تاپ", "12 سایت", "سایت",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5387", "کت چرم", "8 اپلیکیشن", "اپلیکیشن",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5391", "تخفیف دوره ای", "4 سایت", "سایت",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["5393", "نوتیف/تهران/موبایل و دسکتاپ", "1 سایت", "سایت",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
            ["4148", "بنر فروش فوق‌العاده", "10 اپلیکیشن", "اپلیکیشن",
                <ButtonDropdownMenu icon={<ThreeDotsIcon/>} menuItems={buttonDropMenu}/>],
        ]
    }
    return (
        <div className="Site-And-App-Acceptor">
            {/*<DataNotFound image={require("../../../assets/images/icons/DataNotFound2.svg").default}*/}
            {/*              title={"هیج گروهی وجود ندارد"}*/}
            {/*              body={"اگر محتوایی وجود داشته باشد در این بخش نشان داده خواهد شد."}/>*/}

            <>
                <UserContentHeader title={'سایت و اپلیکیشن پذیرنده'}
                                   subtitle={"در این بخش می توانید لیست ناشرین تی‌جار را مشاهده کرده و گروه هایی منتخب از نمایش دهندگان مورد نظر خود را بسازید."}
                                   icon={<></>}
                                   iconColor={"#EF233C"}
                                   box={contentHeaderBox}/>
                <Popup open={openPopup} setOpen={setOpenPopup} title={"ایجاد گروه جدید"}
                       close={() => setOpenPopup(false)}>
                    {popupInside}
                </Popup>
                <Table
                    headers={tableData.headers}
                    bodies={tableData.bodies}
                    headerContent={<TableHeaderContent title={"گروه های من"} subtitle={"۸ گروه"}
                                                       placeholder={"جستجوی گروه"} onClick={() => {
                    }}/>}
                    rowEachPage={8}/>
            </>
        </div>
    )
}

export default SiteAndAppAcceptor